import { render, staticRenderFns } from "./InputNewIdentity.vue?vue&type=template&id=8494f44e"
import script from "./InputNewIdentity.vue?vue&type=script&lang=js"
export * from "./InputNewIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports